import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { apiUrl, myHeaders_Autorized } from "Api/Api";
// import { current_unix_stamp } from "utils/Helper";
import axios from 'axios';
import moment from 'moment';
import sanitize from 'sanitize-filename';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import avatar from 'Assets/rectangle.svg';
import thumb_placeholder from 'Assets/thumb.svg';
import noimage from 'Assets/noimage.png';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import './style.css';
import { myHeaders_Auth_With_Cache_Control, owner_perms, org_friendly_url, user_entity_uuid, events_list_api, HeaderConfig} from 'Api/Api';
// , myHeaders_With_Cache_Control,, user_access_level
import ActivityIndicator from 'components/ActivityIndicator/ActivityIndicator';
import { unixTimeStamp } from 'utils/Helper';
// , unixDateConversion
import FullPageSpinner from 'components/FullPageSpinner/FullPageSpinner';
import { local_routes } from 'utils/Routes';
import MultipleImagesUpload from 'components/MultipleImagesUpload/MultipleImagesUpload';
import ReactTooltip from 'react-tooltip';

const max_additional_images = 8;

class EventDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPublishChecked: false,
            source_owner: false, // to see if we can ever add locations/channels fields
            isCommunityPkChecked: false, // false === normal, true === community_pk
            event_presentation_format: '',
            presentation_submit_event_type: 'normal',
            event_info: {},
            friendly_url: '',
            zoom_webinar_id: '',
            ticketing_url:'',
            recFriendlyUrl: '',
            location_uuid: '',
            locations_text: '',
            entity_uuid: '',
            volumeCount: 1,
            eventTitle: '',
            eventType: '',
            isVolumeChecked: true,
            isTitleChecked: false,
            startDate: '',
            endDate: '',
            description: '',
            price: '',
            uploadImgFile: null,
            coverImgLoader: false,
            uploadBannerImgFile: null,
            uploadThumbFile: null,
            coverBannerImagePreviewUrl: null,
            spotlight_image: null,
            coverImagePreviewUrl: null,
            thumbImagePreviewUrl: null,
            //cover_image_url: null,
            saveDraftLoader: false,
            nextBtnLoader: false,
            validated: false,
            collisionError: '',
            existedId: null,
            eventTypeVal: "night",
            poster_image: null,
            thumb_image: null,
            checkboxStatus: true,
            
            loading: true,
            btnDisableValidate: true,
            //locationData: null,
            isChecked: true,
            //locationCreateEvents: null,
            //location_name: '',
            event_name: null,
            //organizerData: {},
            bannerPosterImage: null,
            multipleImagesArr: [],
            savedAdditionalImages: []
        }
        this.onHandleCheckbox = this.onHandleCheckbox.bind(this);
        
        this.back_to_list = false;
        
        this.workspace_base_url = "";
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
          this.state.isPublishChecked = true;
        }
        
    }

    componentDidUpdate (prevProps) {
        //console.log("YO",prevProps,this.props);
        //if (this.props.location && this.props.location.pathname) {
        let { location: { pathname } } = this.props;

        if (prevProps.location.pathname === pathname) return;
        this.routeChanged();
    }
    
    routeChanged () {
        console.log("ManageEvent Description routeChanged");
        if (!this.props.match.params.otherpage) {
            // resetting to a fresh create PK
            this.setupPage();
        }
        //this.APICalls();
        //this.APIPromises();
    }

    componentDidMount = async function () {
        await this.setupPage();
    }

    handleCancel = async () => {
        let next_page = `${this.workspace_base_url}${local_routes.myevents}`;
        if (this.props.source_info.referrer) {
            next_page = this.props.source_info.referrer;
        }
        this.props.history.push(next_page);
    }
    
    setupPage = async () => {
        let new_state = {...this.state};
        
        console.log("ManageEvent Description setupPage source_info",this.props.source_info);
        
        if (this.props.event_uuid) {
            // EDIT
            if (this.props.source_info.entity_type === 'locations') {
                new_state.location_uuid = this.props.source_info.entity_uuid;
                new_state.locations_text = this.props.source_info.entity_name;
                
                if (owner_perms && owner_perms['locations'] && owner_perms['locations'][new_state.location_uuid] && owner_perms['locations'][new_state.location_uuid] === 'admin') {
                    new_state.source_owner = true;
                }
            }
            if (this.props.source_info.entity_type === 'channels') {
                new_state.channel_uuid = this.props.source_info.entity_uuid;
                new_state.channels_text = this.props.source_info.entity_name;
                if (owner_perms && owner_perms['channels'] && owner_perms['channels'][new_state.channel_uuid] && owner_perms['channels'][new_state.channel_uuid] === 'admin') {
                    new_state.source_owner = true;
                }
            }
            if (this.props.event_info.image_urls) {
                let savedTempArr = [];
                this.props.event_info.image_urls.forEach((item) => {
                    savedTempArr.push({ source: item, name: item.split('/').pop() });
                });
                new_state.savedAdditionalImages = savedTempArr;
            }
            console.log("ManageEvent Description setupPage event_info",this.props.event_info);
            if (this.props.event_info.volume_integer) {
                new_state.volumeCount = this.props.event_info.volume_integer;
            }
            new_state.eventTitle = this.props.event_info.entity_name;
            new_state.friendly_url = this.props.event_info.friendly_url;
            new_state.recFriendlyUrl = this.props.event_info.friendly_url;
            if (this.props.event_info.ticketing_url) {
                new_state.ticketing_url = this.props.event_info.ticketing_url;
            }
            new_state.zoom_webinar_id = this.props.event_info.zoom_webinar_id || '';
            new_state['description'] = this.props.event_info['description'];
            new_state['existedId'] = this.props.event_info.entity_uuid;
            if (this.props.source_info.xref_data && this.props.source_info.xref_data.event_type) {
                new_state.eventType = this.props.source_info.xref_data.event_type;
                new_state.eventTypeVal = this.props.source_info.xref_data.event_type;
                if (new_state.eventType === 'event') {
                    new_state.isTitleChecked = false;
                } else {
                    new_state.isVolumeChecked = true;
                    new_state.isTitleChecked = true;
                    new_state.isVolumeDisabled = true;
                    new_state.isTitleDisabled = true;
                }
            }
            if (this.props.event_info.event_type) {
                new_state.presentation_submit_event_type = this.props.event_info.event_type;
                //new_state.isCommunityPkChecked = true;
            }
            if (this.props.event_info.event_presentation_format) {
                new_state.event_presentation_format = this.props.event_info.event_presentation_format;
            } else {
                new_state.event_presentation_format = '20x20';
            }

            if (this.props.event_info.thumb_image_url) {
                new_state.thumb_image = this.props.event_info.thumb_image_url;
            }           
            if (this.props.event_info.poster_image_url) {
                new_state.poster_image = this.props.event_info.poster_image_url;
            }
            if (this.props.event_info.spotlighted_image_url) {
                new_state.spotlight_image = this.props.event_info.spotlighted_image_url;
            }
            if (this.props.event_info.admission_cost) {
                new_state.admission_cost = this.props.event_info.admission_cost;
            }
            if (this.props.event_info.start_time) {
                new_state.startDate = new Date(this.props.event_info.start_time * 1000);
            } else {
                new_state.startDate = new Date();
            }
            if (this.props.event_info.end_time) {
                new_state.endDate = new Date(this.props.event_info.end_time * 1000);
            } else {
                new_state.endDate = new Date();
            }
        } else {
            // CREATE
            if (this.props.source_info.entity_type === 'locations') {
                new_state.volumeCount = (this.props.source_info.volume_count || 0)+1;
                new_state.eventTitle = `${this.props.source_info.entity_name}-Vol-${new_state.volumeCount}`;
                new_state.friendly_url = `${this.props.source_info.entity_name}-Vol-${new_state.volumeCount}`.toLowerCase();
                new_state.location_uuid = this.props.source_info.entity_uuid;
                new_state.locations_text = this.props.source_info.entity_name;
                new_state.isVolumeChecked = true;
                new_state.isTitleChecked = true;
                new_state.isVolumeDisabled = true;
                new_state.isTitleDisabled = true;
                new_state.eventType = "night";
                new_state.eventTypeVal = "night";
                new_state.source_owner = true;

            } else if (this.props.source_info.entity_type === 'channels') {
                new_state.channel_uuid = this.props.source_info.entity_uuid;
                new_state.channels_text = this.props.source_info.entity_name;
                new_state.eventType = "event";
                new_state.eventTypeVal = "event";
                let tmp_event_title = `${this.props.source_info.entity_name} Event`;
                let tmp_event_freindly_url = tmp_event_title.toLowerCase().replace(/ /g, "-");
                new_state.eventTitle = tmp_event_title;
                new_state.friendly_url = tmp_event_freindly_url;
                new_state.isTitleChecked = false;
                new_state.source_owner = true;
            } else if (this.props.source_info.entity_type === 'organizations') {
                new_state.eventType = "event";
                new_state.eventTypeVal = "event";
                let tmp_event_title = `${this.props.source_info.entity_name} Event`;
                let tmp_event_freindly_url = tmp_event_title.toLowerCase().replace(/ /g, "-");
                new_state.eventTitle = tmp_event_title;
                new_state.friendly_url = tmp_event_freindly_url;
                new_state.isTitleChecked = false;
            }
            new_state.event_presentation_format = '20x20';
                /*
                this.setState({
                    volumeCount: tmp_volumeCount,
                    eventTitle: `${entity_name}-Vol-${tmp_volumeCount}`,
                    friendly_url: `${entity_name}-vol-${tmp_volumeCount}`,
                    //initialTitle: `${entity_name}-Vol-${tmp_volumeCount}`,

                    location_uuid: entity_uuid,
                    locations_text: userDataRes.data.entity_name,
                    //initialCount,
                    entity_name,
                    loading: false
                });            
                */
        }
        new_state.loading = false;
        console.log("ManageEvent Description setupPage new_state",new_state);
        this.setState(new_state);
    }

    // Method to handle changed event type
    onPresentationFormatChange = ({ target: { value } }) => {
        this.setState({ event_presentation_format: value });
    }
    
    // Method to handle changed event type
    onEventChange = ({ target: { value } }) => {
        this.setState({ eventType: value, eventTypeVal: value });
        if (value === 'event') {
            this.setState({ isTitleChecked: false });
        } else {
            const { match: { params: { event_uuid } = {} } = {} } = this.props;
            if (!event_uuid) {
                // JBB - this should only happen on CREATE
                this.setState({
                    isVolumeChecked: true,
                    isTitleChecked: true,
                    isVolumeDisabled: true,
                    isTitleDisabled: true,
                    //eventTypeVal:"night" 
                });
            }
        }
    }

    // Method to handle dropdown input  data
    onInputChange = key => ({ target }) => {
        this.setState({ [key]: target.value })
        if (key === "friendly_url") {
            this.setState({ friendly_url: target.value.toLowerCase().replace(/ /g, "-") })
        }
        //else if (key === "ticketing_url"){
        //    this.setState({ ticketing_url: target.value.toLowerCase().replace(/ /g, "-") })
        //}
        
        // Validation for button disablity to enable when all data is available
        if (this.state.friendly_url !== '' && this.state.eventTitle !== '' && this.state.description !== '' && this.state.description.length > 1 && this.state.startDate !== '' && this.state.endDate !== '') {
            this.setState({ btnDisableValidate: false })
        } else { this.setState({ btnDisableValidate: true }) }
    }

    onPresentationSubmitTypeChange = (presentation_submit_event_type) => {
        console.log("onPresentationSubmitTypeChange",presentation_submit_event_type);
        this.setState({
           presentation_submit_event_type 
        });
    }

    // Method to handdle checkbox data
    onCheckboxSelect = key => () => {
        this.setState({
            [key]: !this.state[key],
        });
    }

    // Method to handle dates
    handleChange = name => date => {
        const { endDate, startDate } = this.state;
        this.setState({
            [name]: date,
        });
        // eslint-disable-next-line 
        if (name === "startDate" && (!endDate || startDate && endDate && moment(date).diff(endDate) >= 0)) {
            this.setState({
                endDate: moment(date).add(2, 'hours').toDate(),
            });
        }
        // eslint-disable-next-line 
        if (name === "endDate" && startDate && endDate && moment(date).diff(startDate) <= 0) {
            this.setState({
                startDate: date,
            });
        }
        // Validation for button disablity to enable when all data is available
        if (this.state.friendly_url !== '' && this.state.eventTitle !== '' && this.state.description !== '' && this.state.description.length > 1 && this.state.startDate !== null && this.state.endDate !== null) {
            if (date !== null) {
                this.setState({ btnDisableValidate: false })
            }
        } else { this.setState({ btnDisableValidate: true }) }
    }
    // Additional Bg Images onchange functionality
    onChangeImages = async (multipleImages) => {
        console.log("onChangeImages",multipleImages);
        multipleImages = multipleImages.sort((a, b) => a.name.localeCompare(b.name));
        if (multipleImages.length > max_additional_images) {
            multipleImages.length = max_additional_images;
        }
        this.setState({multipleImagesArr:multipleImages})
      };

    uploadAdditionalPic = async (image_obj) => {
        if (image_obj && !image_obj.file) {
            return image_obj.source;
        }
        if (image_obj && image_obj.file) {
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(image_obj.file);
                reader.onload = () => resolve(reader.result);
            });

            var conImgName =  image_obj.name.replace(/[^A-Za-z0-9.]/g, "");
            let multi_image_upload_data = await axios.post(`${events_list_api}/${image_obj.entity_uuid}/getUploadSignedUrl?asset_type=images&filename=${conImgName}`, {}, myHeaders_Autorized);
            const config = { headers: { "Content-Type": multi_image_upload_data.data.content_type } };
            let uploadUrl = multi_image_upload_data.data.upload_url;
            
            var arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config)

            return multi_image_upload_data.data.asset_url;
        }
    }

    saveThenBack = async () => {
        console.log("saveThenBack");
        this.back_to_list = true;
    }

    handleSubmitDescriptionData = event => {
        console.log("handleSubmitDescriptionData");
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else if (form.checkValidity() !== false) {
            event.preventDefault();
            this.onVenueClick();
        }
        this.setState({ validated: true })
    }

    onVenueClick = async () => {
        console.log("onVenueClick");
        let shareEventRight = this.state.isChecked ? this.state.isChecked : this.state.isChecked;
        let eventRightTempArr;
        //const { organizerData } = this.state;
        
        let event_uuid = this.props.event_uuid;
        
        if (shareEventRight === false) {
            eventRightTempArr = [{
                entity_uuid: user_entity_uuid,
                xref_data: {
                    //organizer_integer: 1,
                    entity_owner_integer: 1
                }
            }
            ]
        } else {
            let userArr = [];
            let organizerData = [];
            if (this.props.source_info.entity_type === 'channels' || this.props.source_info.entity_type === 'locations') {
                let organizerData_response = await axios.get(`${apiUrl}${this.props.source_info.entity_type}/${this.props.source_info.entity_uuid}/users?filter_obj=${encodeURIComponent('{"entity_owner_integer":{"gte":1}}')}`, HeaderConfig);
                organizerData = organizerData_response.data;
            }
            if (organizerData.length > 1) {
                for (let users of organizerData) {
                    if (users.entity_uuid === user_entity_uuid) {
                        userArr.push({
                            entity_uuid: user_entity_uuid,
                            xref_data: {
                                //organizer_integer: 1,
                                entity_owner_integer: 1
                            }
                        })
                    } else {
                        userArr.push({
                            entity_uuid: users.entity_uuid,
                            xref_data: {
                                //organizer_integer: 2,
                                entity_owner_integer: 2
                            }
                        })
                    }
                }
            } else {
                userArr.push({
                    entity_uuid: user_entity_uuid,
                    xref_data: {
                        //organizer_integer: 1,
                        entity_owner_integer: 1
                    }
                })
            }

            eventRightTempArr = userArr;
        }
        this.setState({ nextBtnLoader: true })
        //const { eventType, eventTitle, volumeCount, description, price, startDate,
        //    endDate, uploadImgFile, locations_text, friendly_url, ticketing_url, existedId, location_uuid, uploadBannerImgFile } = this.state;
        //let { match: { params: { event_uuid } = {} } = {} } = this.props;
        // logic to create event data
        //console.log("ManageEvent Description props",this.props, this.state, eventRightTempArr);
        
        if (!event_uuid) {
            // CREATE event
            // Object data
            let tmp_friendly_url = this.state.friendly_url.toLowerCase().replace(/[\s.,&']/g, "-");
            tmp_friendly_url = sanitize(tmp_friendly_url);

            //let tmp_ticketing_url = ticketing_url.toLowerCase().replace(/[\s.,&']/g, "-");
            //tmp_ticketing_url = sanitize(tmp_ticketing_url);

            let payload = {
                description: this.state['description'],
                //friendly_url: friendly_url.toLowerCase().replace(/ /g, "-"),
                friendly_url: tmp_friendly_url,
                entity_name: this.state.eventTitle,
                zoom_webinar_id: this.state.zoom_webinar_id,
                ticketing_url: this.state.ticketing_url,
                //volume_integer: volumeCount,
                start_time: unixTimeStamp(this.state.startDate),
                end_time: unixTimeStamp(this.state.endDate),
                admission_cost: this.state.price,
                status_code: this.state.isPublishChecked ? 1 : 4,
                users: eventRightTempArr
            }
            if (this.props.source_info.entity_type === 'locations') {
                payload.locations_text = this.state.locations_text;
                payload.locations = [{
                    entity_uuid: this.state.location_uuid,
                    xref_data: {
                        event_type: this.state.eventType,
                    }
                }];
            };
            if (this.props.source_info.entity_type === 'channels') {
                payload.channels_text = this.state.channels_text;
                payload.channels = [{
                    entity_uuid: this.state.channel_uuid,
                    xref_data: {
                        event_type: this.state.eventType,
                    }
                }];
            };
            
            if (this.state.eventType === 'night') {
                payload.volume_integer = this.state.volumeCount;
            }
            
            /*
            if (this.state.isCommunityPkChecked) {
                payload.event_type = 'community_pk';
                //payload.event_presentation_format = '1x20';
            } else {
                payload.event_type = 'normal';
            }
            */
            
            payload.event_type = 'normal';
            if (this.state.presentation_submit_event_type) {
                payload.event_type = this.state.presentation_submit_event_type;
            }
 
            if (this.state.event_presentation_format) {
                payload.event_presentation_format = this.state.event_presentation_format;
            } else {
                payload.event_presentation_format = '20x20';
            }
            
            let res = await axios.post(events_list_api, payload, HeaderConfig);
            
            event_uuid = res.data.entity_uuid;
            //console.log("CREATED EVENT",event_uuid);
            if (this.state.eventType === 'night' && this.state.location_uuid && this.state.source_owner) {
                let locationVolUpdate = { "volume_count": this.state.volumeCount };
                await axios.patch(`${apiUrl}locations/${this.state.location_uuid}`, locationVolUpdate, HeaderConfig);
            }

        } else {
            // EDIT event
            let tmp_friendly_url = this.state.friendly_url.toLowerCase().replace(/[\s.,&]/g, "-");
            tmp_friendly_url = sanitize(tmp_friendly_url);

            //let tmp_ticketing_url = ticketing_url.toLowerCase().replace(/[\s.,&']/g, "-");
            //tmp_ticketing_url = sanitize(tmp_ticketing_url);
            let payload = {
                description: this.state['description'],
                //friendly_url: friendly_url.toLowerCase().replace(/ /g, "-"),
                friendly_url: tmp_friendly_url,
                zoom_webinar_id: this.state.zoom_webinar_id,
                ticketing_url: this.state.ticketing_url,
                entity_name: this.state.eventTitle,
                //volume_integer: volumeCount,
                start_time: unixTimeStamp(this.state.startDate),
                end_time: unixTimeStamp(this.state.endDate),
                locations_text: this.state.locations_text,
                admission_cost: this.state.price
            }
            if (this.props.source_info.entity_type === 'locations' && this.state.source_owner) {
                payload.locations_text = this.state.locations_text;
                payload.locations = [{
                    entity_uuid: this.state.location_uuid,
                    xref_data: {
                        event_type: this.state.eventType,
                    }
                }];
            };
            if (this.props.source_info.entity_type === 'channels' && this.state.source_owner) {
                payload.channels_text = this.state.channels_text;
                payload.channels = [{
                    entity_uuid: this.state.channel_uuid,
                    xref_data: {
                        event_type: this.state.eventType,
                    }
                }];
            };
            if (this.state.eventType === 'night') {
                payload.volume_integer = this.state.volumeCount;
            } else {
                payload.volume_integer = -1;
            }

            payload.event_type = 'normal';
            if (this.state.presentation_submit_event_type) {
                payload.event_type = this.state.presentation_submit_event_type;
            }
 
            if (this.state.event_presentation_format) {
                payload.event_presentation_format = this.state.event_presentation_format;
            } else {
                payload.event_presentation_format = '20x20';
            }
            
            // logic to edit event data
            //await axios.patch(`${events_list_api}/${existedId}`, payload);
            await axios.patch(`${events_list_api}/${event_uuid}`, payload);
            
            if (this.state.zoom_webinar_id) {
                // also sync to zoom
                await axios.post(`${apiUrl}events/${event_uuid}/syncZoomInfo`,{});
            }
        }
        // now do things common to both add and edit
        //this.props.getDescriptionData({ entity_uuid: existedId, entity_name: eventTitle });
        //this.props.getDescriptionData({ entity_uuid: event_uuid, entity_name: eventTitle });
        //const { multipleImagesArr } = this.state;
        console.log("multipleImagesArr",this.state.multipleImagesArr)
        // Additional Background images functionality
        let updateImgArrays = [];
        if (this.state.multipleImagesArr.length > 0) {
            
            let uploadAdditionalPic_promises = [];
            for (let i = 0; i < this.state.multipleImagesArr.length; i++) {
                //multipleImagesArr[i].entity_uuid = existedId;
                let tmp_image_info = {...this.state.multipleImagesArr[i]}
                tmp_image_info.entity_uuid = event_uuid;
                uploadAdditionalPic_promises.push(this.uploadAdditionalPic(tmp_image_info));
            }
            updateImgArrays = await Promise.all(uploadAdditionalPic_promises);
        }
        //await axios.patch(`${apiUrl}events/${existedId}`, { "image_urls": updateImgArrays }, HeaderConfig);
        //console.log("PATCH EVENT",event_uuid);
        await axios.patch(`${apiUrl}events/${event_uuid}`, { image_urls: updateImgArrays }, HeaderConfig);



        const updateThumb = async () => {
            let thumbPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(this.state.uploadThumbFile);
                reader.onload = () => resolve(reader.result);
            });

            let conImgName =  this.state.uploadThumbFile.name.replace(/[^A-Za-z0-9.]/g, "");
            let thumb_image_upload_data = await axios.post(`${events_list_api}/${event_uuid}/getUploadSignedUrl?asset_type=thumb_image&filename=${conImgName}`, {}, myHeaders_Autorized);
            const config = { headers: { "Content-Type": thumb_image_upload_data.data.content_type } };
            let uploadUrl = thumb_image_upload_data.data.upload_url;
            
            let arrVal = await thumbPromise;
            await axios.put(uploadUrl, arrVal, config)
        }
        
        const updatePoster = async () => {
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(this.state.uploadImgFile);
                reader.onload = () => resolve(reader.result);
            });

            var conImgName =  this.state.uploadImgFile.name.replace(/[^A-Za-z0-9.]/g, "");
            let poster_image_upload_data = await axios.post(`${events_list_api}/${event_uuid}/getUploadSignedUrl?asset_type=poster_image&filename=${conImgName}`, {}, myHeaders_Autorized);
            const config = { headers: { "Content-Type": poster_image_upload_data.data.content_type } };
            let uploadUrl = poster_image_upload_data.data.upload_url;
            
            var arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config)
        }
        
        const updateBanner = async () => {
            let coverPicPromise = new Promise(resolve => {
                let reader = new FileReader();
                reader.readAsArrayBuffer(this.state.uploadBannerImgFile);
                reader.onload = () => resolve(reader.result);
            });

            let conImgName =  this.state.uploadBannerImgFile.name.replace(/[^A-Za-z0-9.]/g, "");
            let spotlighted_image_upload_data = await axios.post(`${events_list_api}/${event_uuid}/getUploadSignedUrl?asset_type=spotlighted_image&filename=${conImgName}`, {}, myHeaders_Autorized);
            const config = { headers: { "Content-Type": spotlighted_image_upload_data.data.content_type } };
            let uploadUrl = spotlighted_image_upload_data.data.upload_url;
            
            var arrVal = await coverPicPromise;
            await axios.put(uploadUrl, arrVal, config)
        
        }

        if (this.state.uploadThumbFile !== null) {
            await updateThumb();
        }
        if (this.state.uploadImgFile !== null) {
            await updatePoster();
        }
        if (this.state.uploadBannerImgFile !== null) {
            await updateBanner();
        }
        
        //if (this.state.zoom_webinar_id) {
        //    await axios.post(`${apiUrl}events/${event_uuid}/refreshZoomInfo`,{});
        //}
        
        console.log("Event Creation/Update complete")
        
        let next_page = `${this.workspace_base_url}${local_routes.manageevent}/${event_uuid}/venue`;
        if (this.back_to_list) {
            if (this.props.source_info.referrer) {
                next_page = this.props.source_info.referrer;
            } else {
                next_page = `${this.workspace_base_url}${local_routes.myevents}`;
            }
        }
        
        // bust cache
        if (this.props.event_info.friendly_url && this.props.event_info.status_code === 1) {
            await axios.get(`${apiUrl}events/${this.props.event_info.friendly_url}`,myHeaders_Auth_With_Cache_Control);
        }
        
        this.props.history.push(next_page);
        
        /*
        var self = this;
        // below calls is for handling edit event
        self.props.getRecDesData(event_uuid);
        let editVal = true
        self.getCreatedEventData(event_uuid, true, editVal);
        */
    }

    // Method to get event data
    /*
    getCreatedEventData = (reqid, bool) => {
        const { match: { params: { event_uuid } = {} } = {} } = this.props;
        let ent_uuid = event_uuid;
        if (ent_uuid !== undefined) { this.setState({ btnDisableValidate: false, checkboxStatus: false, isVolumeChecked: false, isTitleChecked: false, }) } else this.setState({ checkboxStatus: true, isVolumeChecked: true, isTitleChecked: true, });
        Promise.all([
            axios.get(`${events_list_api}/${reqid}`, myHeaders_With_Cache_Control)
        ])
            .then(([userDataRes]) => {
                if (userDataRes.data) {

                    let recProps = userDataRes.data;
                    recProps.volume_integer ? this.setState({ volumeCount: recProps.volume_integer, })
                        : this.setState({ volumeCount: recProps.volume_integer });

                    recProps.entity_name ? this.setState({
                        eventTitle: recProps.entity_name,
                    }) : this.setState({ eventTitle: '', });

                    recProps.friendly_url ? this.setState({
                        friendly_url: recProps.friendly_url,
                    }) : this.setState({ friendly_url: '', });

                    recProps.ticketing_url ? this.setState({
                        ticketing_url: recProps.ticketing_url,
                    }) : this.setState({ ticketing_url: '', });

                    recProps.description ? this.setState({
                        description: recProps.description,
                    }) : this.setState({ description: '', });

                    recProps.entity_uuid ? this.setState({
                        existedId: recProps.entity_uuid,
                    }) : this.setState({ existedId: '', });

                    recProps.friendly_url ? this.setState({
                        recFriendlyUrl: recProps.friendly_url,
                    }) : this.setState({ recFriendlyUrl: '', });

                    if (recProps.xref_data && recProps.xref_data.event_type) {
                        this.setState({
                            eventType: recProps.xref_data.event_type,
                        });
                        if (recProps.xref_data.event_type === "event") {
                            this.setState({ isTitleChecked: false, eventTypeVal: "event" });
                        }
                        else {
                            this.setState({
                                isVolumeChecked: true,
                                isTitleChecked: true,
                                isVolumeDisabled: true,
                                isTitleDisabled: true,
                                eventTypeVal: "night"
                            });
                        }

                    }
                    //console.log("recProps.spotlighted_image_url",recProps.spotlighted_image_url)
                    this.setState({ loading: false })
                    if (recProps.poster_image_url) { this.setState({ poster_image: recProps.poster_image_url }); }
                    if (recProps.spotlighted_image_url) { this.setState({ spotlight_image: recProps.spotlighted_image_url }); }
                    if (recProps.admission_cost !== undefined) { this.setState({ price: recProps.admission_cost }); }
                    if (!recProps.start_time) {
                        recProps.start_time = current_unix_stamp;
                    }
                    if (!recProps.end_time) {
                        recProps.end_time = current_unix_stamp;
                    }
                    let conv_start_time = unixDateConversion(recProps.start_time)
                    let conv_end_time = unixDateConversion(recProps.end_time)
                    this.setState({ startDate: conv_start_time, endDate: conv_end_time })
                    if (bool === true) {
                        this.props.history.push(`${local_routes.manageevent}/${recProps.entity_uuid}/venues`)
                        this.props.next();
                    }
                }
            });
    }
    */

    // Change Cover Image method
    onChangeThumbFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var item = files[index];
            this.handleThumbLoadImage(item);
        }
        this.setState({ item, thumb_image: item });

    }

    // Cover image method
    handleThumbLoadImage(item) {
        var pictures = [];
        if (item) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    thumbImagePreviewUrl: reader.result,
                    uploadThumbFile: item
                }));
                pictures.push({ 'image': item, 'thumbImagePreviewUrl': reader.result });
            };
            reader.readAsDataURL(item);
        }
    }

    // Change Cover Image method
    onChangeCoverFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var item = files[index];
            this.handleCoverLoadImage(item);
        }
        this.setState({ item, poster_image: item });

    }

    // Cover image method
    handleCoverLoadImage(item) {
        var pictures = [];
        if (item) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    coverImagePreviewUrl: reader.result,
                    uploadImgFile: item
                }));
                pictures.push({ 'image': item, 'coverImagePreviewUrl': reader.result });
            };
            reader.readAsDataURL(item);
        }
    }
    
    // Change Cover Image method
    onBannerChangeCoverFile = (event) => {
        event.stopPropagation();
        event.preventDefault();
        let files = event.target.files;
        var index;
        for (index = 0; index < files.length; index++) {
            var bannerItem = files[index];
            this.handleBannerCoverLoadImage(bannerItem);
        }
        this.setState({ bannerItem, spotlight_image: bannerItem });

    }
    
    // Cover image method
    handleBannerCoverLoadImage(bannerItem) {
        var picture = [];
        if (bannerItem) {
            const reader = new FileReader();
            reader.onloadend = () => {
                this.setState(() => ({
                    coverBannerImagePreviewUrl: reader.result,
                    uploadBannerImgFile: bannerItem
                }));
                picture.push({ 'image': bannerItem, 'coverBannerImagePreviewUrl': reader.result });
            };
            reader.readAsDataURL(bannerItem);
        }
    }

    onHandleCheckbox = () => {
        this.setState({
            isChecked: !this.state.isChecked // flip boolean value
        })
    }

    render() {
        /*
        const {
            isTitleChecked,
            isVolumeChecked,
            volumeCount,
            ticketing_url,
            eventType,
            eventTitle,
            startDate,
            endDate,
            description,
            price,
            coverImgLoader,
            nextBtnLoader,
            eventTypeVal,
            poster_image,
            checkboxStatus,
            collisionError, friendly_url,
            loading,
            locationCreateEvents,
            spotlight_image,
            savedAdditionalImages
        } = this.state;
        */
        if (this.state.loading) {
            return (
                <div className="spinner-pos">
                    <FullPageSpinner />
                </div>
            )
        }
        else {
            //console.log("Description RENDER; this.state.coverBannerImagePreviewUrl",this.state.coverBannerImagePreviewUrl);
            //console.log("Description RENDER; spotlight_image",spotlight_image);
 
            return (
                <div className="description-sec eventCreation">
                    <ReactTooltip/>
                    <div>
                        <Row className="row-reverse">
                            <Col lg={7} className="venueAlign">
                                <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmitDescriptionData}>
                                    { this.props.source_info.entity_type === 'locations' &&
                                    <React.Fragment>
                                        <Form.Row>
                                            <Form.Group as={Col} md="6" controlId="validationPkTitle">
                                                <Form.Label>Event Type</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    disabled={!this.state.source_owner}
                                                    //disabled={this.props.event_uuid}
                                                    onChange={this.onEventChange}
                                                    required
                                                    value={this.state.eventTypeVal}
                                                >
                                                    <option value="night">PechaKucha Night (City Series w/Volume)</option>
                                                    <option value="event">PechaKucha Event</option>
                                                </Form.Control>
                                            </Form.Group>
                                        </Form.Row>
                                        {
                                            (this.state.eventType === 'night') ?
                                                <Form.Row>
                                                    <Form.Group as={Col} md="12" controlId="validationFriendlyUrl">
                                                        <Form.Label>Volume</Form.Label>
                                                        <Form.Control
                                                            required
                                                            disabled={this.state.isVolumeChecked}
                                                            type="number"
                                                            value={this.state.volumeCount}
                                                            onChange={this.onInputChange('volumeCount')}
                                                        //placeholder="Defaults to next (#10)"
                                                        />
                                                    </Form.Group>
                                                    {
                                                        this.state.checkboxStatus === true &&
                                                        <Form.Group controlId="formBasicCheckbox1">
                                                            <div className="React__checkbox">
                                                                <label className="check-box">
                                                                    <input type="checkbox"
                                                                        className="React__checkbox--input"
                                                                        onChange={this.onCheckboxSelect('isVolumeChecked')}
                                                                        name="check1"
                                                                        checked={this.state.isVolumeChecked}
                                                                    />
                                                                    <span className="React__checkbox--span" />
                                                                    <span className="label-value">Use Next Volume #</span>
                                                                </label>
                                                            </div>
                                                        </Form.Group>
                                                    }
    
                                                </Form.Row>
                                                : null
                                        }
                                    </React.Fragment>
                                    }
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" controlId="validationFriendlyUrl">
                                            <span className="d-flex justify-content-between align-items-center">
                                                <Form.Label>Title{this.state.zoom_webinar_id && <span data-tip='Connected to Zoom' style={{ verticalAlign: "super", fontSize: "x-small", color: "#16a085" }}> ZOOM</span>}</Form.Label>
                                                {(this.props.source_info.entity_type === 'locations' && this.props.source_info.entity_name) ?
                                                    
                                                    <p className="related-name">{this.state.locations_text}</p>
                                                    : this.state.event_name ?
                                                        <p className="related-name">{this.state.event_name}</p>
                                                        : null
                                                }
                                                {/* <p className="related-name">{this.state.locations_text}</p> */}
                                            </span>
                                            <Form.Control
                                                disabled={this.state.isTitleChecked}
                                                required
                                                type="text"
                                                value={this.state.eventTitle}
                                                onChange={this.onInputChange('eventTitle')}
                                            //placeholder="Defaults to next (#10)"
                                            />
                                            <p className="collisionErrorTitle">{this.state.collisionError}</p>
                                        </Form.Group>
                                        <Form.Group as={Col} md="12" controlId="friendly_url">
                                            <Form.Label>Friendly Url</Form.Label>
                                            <Form.Control
                                                disabled={this.state.isTitleChecked}
                                                required
                                                type="text"
                                                value={this.state.friendly_url}
                                                onChange={this.onInputChange('friendly_url')}
                                            //placeholder="Defaults to next (#10)"
                                            />
                                            <p className="collisionErrorTitle">{this.state.collisionError}</p>
                                        </Form.Group>
                                        
                                        {
                                            (this.state.eventType === 'night' && this.state.checkboxStatus === true) ?
                                                <Form.Group controlId="formBasicCheckbox2">
                                                    <div className="React__checkbox">
                                                        <label className="check-box">
                                                            <input type="checkbox"
                                                                className="React__checkbox--input"
                                                                name="check1"
                                                                onChange={this.onCheckboxSelect('isTitleChecked')}
                                                                checked={this.state.isTitleChecked} />
                                                            <span className="React__checkbox--span" />
                                                            <span className="label-value">Use Next Volume #</span>
                                                        </label>
                                                    </div>
                                                </Form.Group> : null
                                        }                                       
                                      </Form.Row>
                                      <Form.Row>
                                            <React.Fragment>
                                                {!this.props.event_uuid &&
                                                <Form.Group as={Col} md="12" controlId="formBasicCheckbox1">
                                                    <div className="React__checkbox">
                                                        <label className="check-box">
                                                            <input type="checkbox"
                                                                className="React__checkbox--input"
                                                                onChange={this.onCheckboxSelect('isPublishChecked')}
                                                                name="check11"
                                                                checked={this.state.isPublishChecked}
                                                            />
                                                            <span className="React__checkbox--span" />
                                                            <span className="label-value">Publish On Creation</span>
                                                        </label>
                                                    </div>
                                                </Form.Group>
                                                }
                                                <Form.Group as={Col} md="6" controlId="validationPkTitle">
                                                    <Form.Label>Event Presentation Format</Form.Label>
                                                    <Form.Control
                                                        //disabled={this.props.event_uuid !== undefined}
                                                        as="select"
                                                        onChange={this.onPresentationFormatChange}
                                                        required
                                                        value={this.state.event_presentation_format}
                                                    >
                                                        <option value="20x20">20x20</option>
                                                        <option value="10x10">10x10</option>
                                                        <option value="5x5">5x5</option>
                                                        <option value="1x20">1x20</option>
                                                        <option value="10x20">10x20</option>
                                                        <option value="any">Any</option>
                                                    </Form.Control>
                                                </Form.Group>
                                                <Form.Group controlId="event_event_type">
                                                    <Form.Label>Presentation Submissions</Form.Label>
                                                    <div className="React__checkbox">
                                                        <label className="check-box">                                                   
                                                            <input type="radio"
                                                                className="React__checkbox--input"
                                                                //id='normal'
                                                                name="presentation_submit_event_type"
                                                                //type='radio'
                                                                onChange={() => this.onPresentationSubmitTypeChange('normal')}
                                                                checked={this.state.presentation_submit_event_type === 'normal' ? true : false}
                                                                //label="Only invited presenters can submit presentations"
                                                            />
                                                            <span className="React__checkbox--span" />
                                                            <span className="label-value">Invited presenters can submit presentations</span>
                                                        </label>
                                                    </div>
                                                    <div className="React__checkbox">
                                                        <label className="check-box">                                                   
                                                            <input type="radio"
                                                                className="React__checkbox--input"
                                                                //id='normal'
                                                                name="presentation_submit_event_type"
                                                                //type='radio'
                                                                onChange={() => this.onPresentationSubmitTypeChange('community_pk')}
                                                                checked={this.state.presentation_submit_event_type === 'community_pk' ? true : false}
                                                                //label="Only invited presenters can submit presentations"
                                                            />
                                                            <span className="React__checkbox--span" />
                                                            <span className="label-value">Any user can submit presentations (Community PK Event)</span>
                                                        </label>
                                                    </div>
                                                </Form.Group>
                                            
                                                {/*
                                                <Form.Group controlId="event_event_type">
                                                        <div className="React__checkbox">
                                                            <label className="check-box">
                                                                <input type="checkbox"
                                                                    //disabled={this.props.event_uuid !== undefined}
                                                                    className="React__checkbox--input"
                                                                    name="event_event_type"
                                                                    onChange={this.onCheckboxSelect('isCommunityPkChecked')}
                                                                    checked={this.state.isCommunityPkChecked} />
                                                                <span className="React__checkbox--span" />
                                                                <span className="label-value">Community PK Event (any user can submit presentations)</span>
                                                            </label>
                                                        </div>
                                                </Form.Group>
                                                */}
                                            </React.Fragment>
                                        
                                        
                                        
                                        
 
                                    </Form.Row>
                                    { (this.props.source_info.entity_type !== 'organizations' && !this.props.event_uuid) &&
                                        <Form.Row>
                                            <Form.Group controlId="formBasicCheckbox2">
                                                <div className="React__checkbox">
                                                    <label className="check-box">
                                                        <input type="checkbox"
                                                            className="React__checkbox--input"
                                                            name="check3"
                                                            defaultChecked={this.state.isChecked}
                                                            onChange={this.onHandleCheckbox}
                                                        />
                                                        <span className="React__checkbox--span" />
                                                        <span className="label-value">Share Event Owner Rights With Other Admins</span>
                                                    </label>
                                                </div>
                                            </Form.Group>
                                        </Form.Row>
                                    }
                                    <Form.Row>
                                    <Form.Group as={Col} md="12" controlId="ticketing_url">
                                            <Form.Label>Ticketing Url</Form.Label>
                                            <Form.Control
                                                // disabled={isTitleChecked}
                                                // required
                                                type="text"
                                                value={this.state.ticketing_url}
                                                onChange={this.onInputChange('ticketing_url')}
                                                placeholder="Should start with 'https://'"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="8" controlId="validationFriendlyUrl">
                                            <Form.Label>Start Date{this.state.zoom_webinar_id && <span data-tip='Connected to Zoom' style={{ verticalAlign: "super", fontSize: "x-small", color: "#16a085" }}> ZOOM</span>}</Form.Label>
                                            <DatePicker
                                                required
                                                className="form-control datePicker-width"
                                                placeholderText="Select start date"
                                                minDate={new Date(1104537600000)}
                                                selected={this.state.startDate}
                                                timeIntervals={15}
                                                timeCaption="Time"
                                                showTimeSelect
                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                onChange={this.handleChange('startDate')}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="8" controlId="validationFriendlyUrl">
                                            <Form.Label>End Date</Form.Label>
                                            <DatePicker
                                                required
                                                className="form-control datePicker-width"
                                                placeholderText="Select end date"
                                                minDate={new Date(1104537600000)}
                                                selected={this.state.endDate}
                                                timeIntervals={15}
                                                timeCaption="Time"
                                                showTimeSelect
                                                dateFormat="MMMM d, yyyy h:mm aa"
                                                onChange={this.handleChange('endDate')}
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    <Form.Row>
                                        <Form.Group as={Col} md="" controlId="validationFriendlyUrl">
                                            <Form.Label>Admission Price</Form.Label>
                                            <Form.Control
                                                type="text"
                                                value={this.state.price}
                                                onChange={this.onInputChange('price')}
                                                placeholder=""
                                            />

                                        </Form.Group>
                                    </Form.Row>
                                    {/*
                                    { user_access_level === 'admin' &&
                                    <Form.Row>
                                        <Form.Group as={Col} md="12" controlId="zoom_webinar_id">
                                            <Form.Label>PK Zoom Webinar ID</Form.Label>
                                            <Form.Control
                                                // disabled={isTitleChecked}
                                                // required
                                                type="text"
                                                value={this.state.zoom_webinar_id}
                                                onChange={this.onInputChange('zoom_webinar_id')}
                                                placeholder="eg. '123 4567 8900' or '12345678900'"
                                            />
                                        </Form.Group>
                                    </Form.Row>
                                    }
                                    */}
                                    <Form.Group controlId="validationDescription">
                                        <Form.Label>DESCRIPTION{this.state.zoom_webinar_id && <span data-tip='Connected to Zoom' style={{ verticalAlign: "super", fontSize: "x-small", color: "#16a085" }}> ZOOM</span>}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            value={this.state['description']}
                                            onChange={this.onInputChange('description')}
                                            placeholder="Write 2-4 sentences that describe your PK with enough detail that anyone who sees this description will understand what's being presented."
                                            rows="8"
                                            required
                                        />
                                    </Form.Group>
                                    <div className="form-group btn-eventposition">
                                        {
                                            this.state.nextBtnLoader === false ?
                                                <React.Fragment>
                                                    <Button style={{ marginRight: "5px" }} size="sm" variant="secondary" onClick={this.handleCancel}>Cancel</Button>
                                                    <Button style={{ marginRight: "5px" }} size="sm" type="submit" variant="pkprimary" onClick={this.saveThenBack}>Save</Button>
                                                    <Button size="sm" type="submit" variant="pkprimary">Save + Next</Button>
                                                </React.Fragment>
                                                :
                                                <ActivityIndicator theme="button-Status-Loader nextbtn-loader" />
                                        }
                                    </div>
                                </Form>
                            </Col>
                            <Col lg={5} className="pad10">
                                <Row>
                                <div className="upload-file-container-image mb-5">
                                    <p data-tip="Large horizontally oriented image that will be displayed at the top of your event page; will span 100% of the width of the screen" className="pl-0" style={{ paddingBottom: "8px" }}>Primary Background Image</p>
                                    <p className="instrux">Displayed at the top of the page. Wide format (4:1 ratio) recommended</p>
                                    <fieldset>
                                        <div className="input-file-row-1 coverImgData">
                                            <div className="upload-file-cover-image banner-upload-image">
                                                {
                                                    (this.state.coverBannerImagePreviewUrl !== null)
                                                        ?
                                                        <img id="preview_image" src={this.state.coverBannerImagePreviewUrl} alt="upload img" />
                                                        :
                                                        (this.state.spotlight_image)
                                                            ?
                                                            <div className="posterImage">
                                                                <img id="preview_image" src={this.state.spotlight_image} alt="apiImg" />
                                                            </div>
                                                            :
                                                            <div className="posterImage">
                                                                <img id="preview_image" src={noimage} alt="coverImg" />
                                                            </div>
                                                }
                                            </div>
                                        </div>
                                    </fieldset>
                                    <div>
                                        <div className='one_opacity_0'>
                                            <input
                                                type="file"
                                                label="add"
                                                id="myInput"
                                                ref={(ref) => this.uploadBgCover = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onBannerChangeCoverFile.bind(this)} />
                                        </div>
                                        {
                                            this.state.coverImgLoader === false ?
                                                <span
                                                    // className="coverUploadImage"
                                                    label="Open File"
                                                    variant="primary"
                                                    //primary={false}
                                                    className="coverImage-btn"
                                                    onClick={() => { this.uploadBgCover.click() }}>Upload Primary Background Image</span>
                                                :
                                                <ActivityIndicator theme="button-Status-Loader" />
                                        }
                                    </div>
                                </div>
                                </Row>
                                <Row>
                                <div className="extra-info pl-0">
                                    <div className="d-flex">
                                        <div className="coverProfile">
                                            <div className="upload-file-container-image d-flex align-items-center">
                                                <fieldset>
                                                    <div className="input-file-row-1 coverImgData">
                                                        <div className="upload-file-cover-image">
                                                            {
                                                                (this.state.coverImagePreviewUrl !== null)
                                                                    ?
                                                                    <img id="preview_image" src={this.state.coverImagePreviewUrl} alt="upload img" />
                                                                    :
                                                                    (this.state.poster_image !== undefined && this.state.poster_image !== null)
                                                                        ?
                                                                        <div className="posterImage">
                                                                            <img id="preview_image" src={this.state.poster_image} alt="apiImg" />
                                                                        </div>
                                                                        :
                                                                        <div className="posterImage">
                                                                            <img id="preview_image" src={avatar} alt="coverImg" />
                                                                        </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </fieldset>
                                                <div>
                                                    <p data-tip="This image will display on top of background images at the top of your event page; translucent (.png) images allowed" style={{ paddingBottom: "8px" }}>Event Poster Image</p>
                                                    <p className="instrux">Vertically-oriented image (2:3 ratio) recommended</p>
                                                    <div className='one_opacity_0'>
                                                        <input
                                                            accept="image/*"
                                                            type="file"
                                                            label="add"
                                                            id="myInput"
                                                            ref={(ref) => this.uploadCover = ref}
                                                            style={{ display: 'none' }}
                                                            onChange={this.onChangeCoverFile.bind(this)} />
                                                    </div>
                                                    {
                                                        this.state.coverImgLoader === false ?
                                                            <span
                                                                // className="coverUploadImage"
                                                                label="Open File"
                                                                variant="primary"
                                                                //primary={false}
                                                                className="d-inline-table coverImage-btn"
                                                                onClick={() => { this.uploadCover.click() }}>Upload Poster Image</span>
                                                            :
                                                            <ActivityIndicator theme="button-Status-Loader" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </Row>
                                <Row>
                                <div className="extra-info pl-0">
                                    <div className="d-flex">
                                        <div className="coverProfile">
                                            <div className="upload-file-container-image d-flex align-items-center">
                                                <fieldset>
                                                    <div className="input-file-row-1 coverImgData">
                                                        <div className="upload-file-thumb-image">
                                                            {
                                                                (this.state.thumbImagePreviewUrl !== null)
                                                                    ?
                                                                    <img id="preview_image" src={this.state.thumbImagePreviewUrl} alt="upload img" />
                                                                    :
                                                                    (this.state.thumb_image !== undefined && this.state.thumb_image !== null)
                                                                        ?
                                                                        <div className="thumbImage">
                                                                            <img id="preview_image" src={this.state.thumb_image} alt="apiImg" />
                                                                        </div>
                                                                        :
                                                                        <div className="thumbImage">
                                                                            <img id="preview_image" src={thumb_placeholder} alt="coverImg" />
                                                                        </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </fieldset>                                                
                                                <div>
                                                    <p data-tip="Smaller image that will be displayed anywhere your event is listed" style={{ paddingBottom: "8px" }}>Event Thumb Image</p>
                                                    <p className="instrux">16:9 ratio recommended</p>
                                                    <div className='one_opacity_0'>
                                                        <input
                                                            accept="image/*"
                                                            type="file"
                                                            label="add"
                                                            id="myInput"
                                                            ref={(ref) => this.uploadThumb = ref}
                                                            style={{ display: 'none' }}
                                                            onChange={this.onChangeThumbFile.bind(this)} />
                                                    </div>
                                                    {
                                                        this.state.coverImgLoader === false ?
                                                            <span
                                                                // className="coverUploadImage"
                                                                label="Open File"
                                                                variant="primary"
                                                                //primary={false}
                                                                className="d-inline-table coverImage-btn"
                                                                onClick={() => { this.uploadThumb.click() }}>Upload Thumb Image </span>
                                                            :
                                                            <ActivityIndicator theme="button-Status-Loader" />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </Row>
                            </Col>
                        </Row>
                        <Row className="additional-background">
                            <Col>
                                <MultipleImagesUpload
                                    onChangeImages={this.onChangeImages}
                                    
                                    // imageValidator={imageValidator}
                                    
                                    //multipleImagesArr={this.state.multipleImagesArr}
                                    
                                    savedMultiImages={this.state.savedAdditionalImages}
                                    
                                    uploadErrorMessage={this.uploadErrorMessage}
                                />
                            </Col>

                        </Row>
                    </div>
                </div>
            );
        }
    }
}

export default withRouter(EventDescription);
